import { useState } from "react";
import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "../site/Reveal";
import { RANGES } from "../../data/products";

const MODES = [
  { key: "rum", label: "Ruminants", range: RANGES[0] },
  { key: "aqua", label: "Fish & shrimp", range: RANGES[1] },
];

export const ModeOfAction = () => {
  const [mode, setMode] = useState("rum");
  const [step, setStep] = useState(0);
  const r = MODES.find((m) => m.key === mode).range;

  return (
    <section data-testid="mode-of-action-section" className="relative bg-[var(--forest)] text-[var(--bone)] grain overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionLabel index="03" light>Mode of action</SectionLabel>
          <Reveal as="h2" className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] mt-8">
            From the first scent to the <em className="text-[#8DC63F]">last bite.</em>
          </Reveal>
          <p className="mt-6 text-[#C9D6C8] leading-relaxed max-w-md">
            Animals decide to eat long before they taste. Our blends work along that sensory path — attraction, acceptance and sustained intake.
          </p>
          <div className="mt-10 inline-flex rounded-full border border-white/20 p-1">
            {MODES.map((m) => (
              <button
                key={m.key}
                data-testid={`moa-toggle-${m.key}`}
                onClick={() => { setMode(m.key); setStep(0); }}
                className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-[background-color,color] duration-300 ${mode === m.key ? "bg-[#8DC63F] text-[var(--forest)]" : "text-[#DCE6DA] hover:text-white"}`}
              >
                {m.label}
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="space-y-3">
            {r.steps.map((s, i) => (
              <button
                key={s.t}
                data-testid={`moa-step-${i}`}
                onMouseEnter={() => setStep(i)}
                onClick={() => setStep(i)}
                className={`w-full text-left rounded-2xl border px-6 md:px-8 py-6 md:py-7 flex items-center gap-6 transition-[background-color,border-color] duration-500 ${step === i ? "bg-white/[0.07] border-[#8DC63F]/60" : "border-white/10 hover:border-white/30"}`}
              >
                <span className="font-mono text-sm text-[#8DC63F]">0{i + 1}</span>
                <span className="flex-1">
                  <span className="block font-display text-3xl md:text-5xl font-light">{s.t}</span>
                  <motion.span
                    initial={false}
                    animate={{ height: step === i ? "auto" : 0, opacity: step === i ? 1 : 0 }}
                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                    className="block overflow-hidden text-[#C9D6C8] text-base md:text-lg"
                  >
                    <span className="block pt-2">{s.d}</span>
                  </motion.span>
                </span>
                <motion.span
                  animate={{ scale: step === i ? 1 : 0.4, opacity: step === i ? 1 : 0.3 }}
                  className="h-3 w-3 rounded-full bg-[#8DC63F]"
                />
              </button>
            ))}
          </div>
          <p className="mt-8 font-mono text-xs text-[#AFC2AE]">Featured range: <span className="text-[#8DC63F]">{r.name}</span> — {r.category}</p>
        </div>
      </div>
    </section>
  );
};
